export default "https://cdn-gra.amplement.io/statics/images/placeholder/tourDashboardPlaceholder.svg";